import { forwardRef, useImperativeHandle, useRef, useState } from "react"
import EventProduct from "./EventProduct"

export default forwardRef(function EventProductsList ({
  eventProducts: eventProductsData,
  onUpdate
}, ref) {
  const [eventProducts, setEventProducts] = useState(eventProductsData || [])
  const eventProductRefs = useRef([])

  const handleUpdate = (eventProduct, index) => {
    const newEventProducts = [ ...eventProducts ]
    newEventProducts[index] = eventProduct
    setEventProducts(newEventProducts)
    onUpdate(newEventProducts)
  }

  useImperativeHandle(ref, () => ({
    isValid: () => eventProducts.every((eventProduct, index) => {
      return eventProductRefs.current[index]?.isValid?.() ?? false
    })
  }), [eventProducts])

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '15px'
    }}>
      {eventProducts?.length > 0 &&
        <>
          <div>Please enter how many days of each of the below were delivered.</div>
          <div style={{ paddingTop: '15px' }}>
            <div style={{
              display: 'flex',
              gap: '15px',
            }}>
              <div style={{ width: "35%" }}></div>
              <div style={{ width: "15%" }}>Expected Days</div>
              <div style={{ width: "15%" }}>Delivered Days</div>
            </div>
          </div>
          <div>
            {eventProducts.map((s,i) => {
              return (
                <EventProduct
                  key={i}
                  ref={productRef => { eventProductRefs.current[i] = productRef }}
                  eventProduct={s}
                  onUpdate={(u) => handleUpdate(u,i)}
                />
              )
            })}
          </div>
        </>
      }
    </div>
  )
})
